import type { StartRumEvent } from '@/types/logger.types'

export type RumEventParams = Parameters<ReturnType<StartRumEvent>>[0]

// RUM event helper - tracks initial request timing and handles refreshes
export const createRumTracker = (operationName: string, startRumEvent: StartRumEvent) => {
    let pending: ReturnType<StartRumEvent> | null = startRumEvent({
        operationName,
    })
    return {
        // Send initial RUM event (only once)
        send: (params: RumEventParams) => {
            if (pending) {
                pending(params)
                pending = null
            } else {
                // Send RUM event for refresh (creates new event)
                startRumEvent({ operationName })(params)
            }
        },
    }
}
